// Debug script to test GPA API endpoints
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://nhhs-analytics-dev-production.up.railway.app';

// Flag to test enhanced API
const TEST_ENHANCED = true;
const API_PATH = TEST_ENHANCED ? '/api/gpa-enhanced' : '/api/gpa';

// Test basic connectivity
async function testBasicConnectivity() {
  console.log('🔍 Testing basic connectivity...');
  try {
    const response = await fetch(`${BACKEND_URL}/api/hello`);
    const data = await response.json();
    console.log('✅ Basic connectivity OK:', data);
    return true;
  } catch (error) {
    console.error('❌ Basic connectivity failed:', error);
    return false;
  }
}

// Test GPA health endpoint
async function testGPAHealth() {
  console.log(`🔍 Testing GPA health endpoint (${TEST_ENHANCED ? 'enhanced' : 'standard'})...`);
  try {
    const response = await fetch(`${BACKEND_URL}${API_PATH}/health`);
    const data = await response.json();
    console.log('✅ GPA health OK:', data);
    return true;
  } catch (error) {
    console.error('❌ GPA health failed:', error);
    return false;
  }
}

// Test GPA load endpoint (this will fail auth, but should not give NetworkError)
async function testGPALoad() {
  console.log('🔍 Testing GPA load endpoint (expect 401 auth error, not NetworkError)...');
  try {
    const response = await fetch(`${BACKEND_URL}/api/gpa/load/test-user`, {
      headers: {
        'Authorization': 'Bearer fake-token'
      }
    });
    
    if (response.status === 401) {
      console.log('✅ GPA load endpoint reachable (got expected 401 auth error)');
      return true;
    } else {
      const data = await response.text();
      console.log('🤔 Unexpected response:', response.status, data);
      return false;
    }
  } catch (error) {
    console.error('❌ GPA load failed with NetworkError:', error);
    return false;
  }
}

// Test CORS preflight
async function testCORSPreflight() {
  console.log('🔍 Testing CORS preflight...');
  try {
    const response = await fetch(`${BACKEND_URL}/api/gpa/health`, {
      method: 'OPTIONS',
      headers: {
        'Origin': window.location.origin,
        'Access-Control-Request-Method': 'GET',
        'Access-Control-Request-Headers': 'Authorization'
      }
    });
    console.log('✅ CORS preflight OK:', response.status);
    return true;
  } catch (error) {
    console.error('❌ CORS preflight failed:', error);
    return false;
  }
}

// Run all tests
async function runDiagnostics() {
  console.log('🚀 Starting GPA API diagnostics...');
  console.log('Backend URL:', BACKEND_URL);
  console.log('Frontend URL:', window.location.origin);
  
  await testBasicConnectivity();
  await testGPAHealth();
  await testCORSPreflight();
  await testGPALoad();
  
  console.log('🏁 Diagnostics complete');
}

// Export for console use
window.debugGPA = {
  runDiagnostics,
  testBasicConnectivity,
  testGPAHealth,
  testGPALoad,
  testCORSPreflight
};

